import type { SVGProps } from 'react';

export const Explorer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'explorer'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
      <rect height={32} width={32} x={0} y={0} />
      <path
        d="M8.84603442,2.34430024 C14.2838641,-1.49139594 21.7888705,-0.287410784 25.7540279,5.05675273 C29.7191854,10.4009162 28.6957492,17.9326676 23.4483333,22.025 L23.4483333,22.025 L31.7633333,30.965 C31.9735797,31.2022203 31.9559142,31.5639199 31.723552,31.7795231 C31.4911897,31.9951263 31.1291812,31.9857167 30.9083333,31.7583333 L30.9083333,31.7583333 L22.4866667,22.7033333 C16.8709632,26.2735479 9.43241128,24.7106512 5.72838805,19.1822907 C2.02436482,13.6539303 3.40820471,6.17999641 8.84603442,2.34430024 Z M15.9116667,1.19166654 C9.76870366,1.19901362 4.79068028,6.17703699 4.78333321,12.32 C4.78265923,16.8219681 7.49414959,20.8809868 11.6532968,22.6041268 C15.812444,24.3272668 20.6000595,23.3751372 23.7834317,20.191765 C26.9668039,17.0083928 27.9189335,12.2207773 26.1957935,8.06163011 C24.4726535,3.90248292 20.4136347,1.19099257 15.9116667,1.19166654 Z M11.88,11.1066667 L11.88,17.3283333 L8.85666667,17.3283333 L8.85666667,11.1066667 L11.88,11.1066667 Z M17.2233333,8.69833333 L17.2233333,17.3283333 L14.2,17.3283333 L14.2,8.69833333 L17.2233333,8.69833333 Z M22.5666667,6.33 L22.5666667,17.3283333 L19.5433333,17.3283333 L19.5433333,6.33 L22.5666667,6.33 Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
